import { createContext, useContext, useEffect, useMemo } from 'react';
import { setPrimaryTracker } from 'usage-tracker-container';
import { useFeatureTableSessionCache } from './feature-table/FeatureTableSessionCacheProvider';
import { jsx as _jsx } from "react/jsx-runtime";
let TRACKER_CACHE = undefined;
const FeatureMonetizationTrackingContext = /*#__PURE__*/createContext(null);
const TRACKER_NAME = 'feature-monetization-library-tracker';
export const FeatureMonetizationTrackerProvider = ({
  tracker,
  children
}) => {
  const {
    screen
  } = useFeatureTableSessionCache();
  const trackingValue = useMemo(() => {
    if (!tracker) {
      return {
        track: () => {},
        isReady: false,
        featureMonetizationLibraryTracker: undefined
      };
    }

    // Create isolated tracker for library use
    const featureMonetizationLibraryTracker = tracker.clone({
      standalone: true,
      preserveTrackerProperties: false,
      trackerName: TRACKER_NAME
    });

    // Register with container for global access within library
    if (!TRACKER_CACHE) {
      TRACKER_CACHE = tracker;
      setPrimaryTracker(featureMonetizationLibraryTracker, TRACKER_NAME);
    }
    const track = properties => {
      try {
        featureMonetizationLibraryTracker.track('Feature Monetization', 'Object Interacted', Object.assign({}, properties));
      } catch (error) {
        console.error(`${TRACKER_NAME} tracking failed:`, error);
      }
    };
    return {
      track,
      isReady: true,
      featureMonetizationLibraryTracker
    };
  }, [tracker]);
  useEffect(() => {
    if (screen && trackingValue.featureMonetizationLibraryTracker) {
      trackingValue.featureMonetizationLibraryTracker.setProperties({
        screen
      });
    }
  }, [screen, trackingValue.featureMonetizationLibraryTracker]);
  return /*#__PURE__*/_jsx(FeatureMonetizationTrackingContext.Provider, {
    value: trackingValue,
    children: children
  });
};
export const useFeatureMonetizationTracker = () => {
  const context = useContext(FeatureMonetizationTrackingContext);
  if (context === null) {
    throw new Error('useFeatureMonetizationTracker must be used within a FeatureMonetizationTrackerProvider');
  }
  return context;
};